import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface AtonHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

export const AtonHoverLabels = ({ form }: AtonHoverLabelsProps) => {
  const { messages } = useLocalization();

  const ATON_HOVER_FIELDS = [
    { name: 'aton_mmsi', label: messages.settingsMapAtonHoverMmsiLabel, description: messages.settingsMapAtonHoverMmsiDescription },
    { name: 'aton_country', label: messages.settingsMapAtonHoverCountryLabel, description: messages.settingsMapAtonHoverCountryDescription },
    { name: 'aton_latitude', label: messages.settingsMapAtonHoverLatitudeModeLabel, description: messages.settingsMapAtonHoverLatitudeDescription },
    { name: 'aton_longitude', label: messages.settingsMapAtonHoverLongitudeLabel, description: messages.settingsMapAtonHoverLongitudeDescription },
    { name: 'aton_assignedMode', label: messages.settingsMapAtonHoverAssignedModeLabel, description: messages.settingsMapAtonHoverAssignedModeDescription },
    { name: 'aton_atonType', label: messages.settingsMapAtonHoverAtonTypeLabel, description: messages.settingsMapAtonHoverAtonTypeDescription },
    { name: 'aton_length', label: messages.settingsMapAtonHoverLengthLabel, description: messages.settingsMapAtonHoverLengthDescription },
    { name: 'aton_offPosition', label: messages.settingsMapAtonHoverOffPositionModeLabel, description: messages.settingsMapAtonHoverOffPositionDescription },
    { name: 'aton_state', label: messages.settingsMapAtonHoverStateLabel, description: messages.settingsMapAtonHoverStateDescription },
    { name: 'aton_status', label: messages.settingsMapAtonHoverStatusLabel, description: messages.settingsMapAtonHoverStatusDescription },
    { name: 'aton_width', label: messages.settingsMapAtonHoverWidthLabel, description: messages.settingsMapAtonHoverWidthDescription },
    { name: 'aton_targetType', label: messages.settingsMapAtonHoverTargetTypeLabel, description: messages.settingsMapAtonHoverTargetTypeDescription },
  ] as const;

  return (
    <div className="grid grid-cols-2 gap-4">
      {ATON_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
